import React from 'react';
import PropTypes from 'prop-types';
import Helmet from 'react-helmet';
import Media from 'react-media';

import HeaderBanner from '../Main/services/HeaderBanner';
import Quality from '../Main/about/Quality';
import Certifications from '../Main/about/Certifications';
import Tools from '../Main/about/Tools';
import ContactUs from '../Footer/ContactUs';

const About = ({ data }) => {
  const hreflang = data.node_locale === 'fr' ? 'en' : 'fr';

  return (
    <div>
      <Helmet>
        <html lang={data.node_locale} />
        <title>{`Offshore Services - ${data.aboutTitle}`}</title>
        <meta name="description" content={data.metaDescription} />
        <link
          rel="alternate"
          hreflang={hreflang}
          href={`https://www.offshoreservices.fr/${hreflang}/about/`}
        />
      </Helmet>
      {/* HEADER */}
      <Media query={{ minWidth: 768 }}>
        {matches =>
          matches ? (
            <div style={{ marginBottom: 195 }}>
              <HeaderBanner title={data.aboutTitle} image={data.headerImage} />
            </div>
          ) : (
            <div style={{ marginBottom: 215 }}>
              <HeaderBanner title={data.aboutTitle} image={data.headerImage} />
            </div>
          )
        }
      </Media>
      {/* QUALITY */}
      <div className="container">
        <Quality
          title={data.aboutQualityTitle}
          contentHTML={
            data.childContentfulAboutPageAboutQualityContentTextNode
              .childMarkdownRemark.html
          }
        />
      </div>
      {/* CERTIFICATIONS */}
      <div style={{ backgroundColor: '#f5f5f5' }}>
        <div className="container">
          <Certifications
            title={data.aboutCertificationTitle}
            contentHTML={
              data.childContentfulAboutPageAboutCertificationContentTextNode
                .childMarkdownRemark.html
            }
            image={data.aboutCertificationImage}
          />
        </div>
      </div>
      {/* TOOLS */}
      <div className="container">
        <Tools
          title={data.aboutToolsTitle}
          contentHTML={
            data.childContentfulAboutPageAboutToolsContentTextNode
              .childMarkdownRemark.html
          }
          videoId={data.aboutToolsYoutube}
        />
      </div>

      <ContactUs locale={data.node_locale} />
    </div>
  );
};

About.propTypes = {
  data: PropTypes.object.isRequired,
};

export default About;



// WEBPACK FOOTER //
// ./src/components/Pages/About.js